import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { CalcType } from './CalcType';

@Injectable({
    providedIn: 'root'
})
export class CalcTypeService {
    private url = `${environment.apiLocation}/CalcType`;
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    public getCalcType(calcType?: string): Observable<CalcType[]> {
        return !!calcType
            ? this.http.get<CalcType[]>(`${this.url}?costsubtype=${calcType}`)
            : this.http.get<CalcType[]>(`${this.url}`);
    }
}
